module.exports = __webpack_public_path__ + "img/Monte_Kope_100.97fefaba.jpg";